import QueryParser from '@/js/libs/QueryParser';
import appRouter from '@/js/helpers/app-router';

export default class Queues {
    constructor(http, gate, useQuery) {
        this.queryParser = useQuery
            ? new QueryParser('queues')
            : null;

        this.gate = gate;
        this.http = http;
    }

    get isLoading() {
        return this.http.isLoading;
    }

    canBrowse() {
        return this.gate.allow('browse', 'queue');
    }

    canRead(queue) {
        return this.gate.allow('read', 'queue', queue);
    }

    canAdd() {
        return this.gate.allow('add', 'queue');
    }

    canEdit(queue) {
        return this.gate.allow('edit', 'queue', queue);
    }

    canDestroy(queue) {
        return this.gate.allow('destroy', 'queue', queue);
    }

    canRestore(queue) {
        return this.gate.allow('restore', 'queue', queue);
    }

    canSort(queue) {
        return this.gate.allow('sort', 'queue', queue);
    }

    canMoveUp(queue) {
        return this.gate.allow('updateSortIndex', 'queue', queue, queue.previous_index);
    }

    canMoveDown(queue) {
        return this.gate.allow('updateSortIndex', 'queue', queue, queue.next_index);
    }

    canReorderPublication(queue) {
        return this.gate.allow('reorderPublication', 'queue', queue);
    }

    index(payload) {
        const params = this.queryParser && this.queryParser.parse(payload) || payload;
        const url = appRouter('api.queues.index', params || {});

        return this.http.get(url).then((response) => {
            const collection = response.data.data;
            const meta = response.data.meta || {};

            return {collection, meta};
        });
    }

    create() {
        return appRouter('queues.create');
    }

    show(queue) {
        return appRouter('queues.show', {queue: queue.id});
    }

    edit(queue) {
        return appRouter('queues.edit', {queue: queue.id});
    }

    store(data) {
        const url = appRouter('api.queues.store');

        return this.http.post(url, data)
            .then((response) => response.data.data);
    }

    update(queue, data) {
        const url = appRouter('api.queues.update', {queue: queue.id});

        return this.http.patch(url, data)
            .then((response) => response.data.data);
    }

    destroy(queue) {
        const url = appRouter('api.queues.destroy', {queue: queue.id});

        return this.http['delete'](url)
            .then((response) => {
                if (response.data && response.data.deleted_at) {
                    return response.data.deleted_at;
                }

                return true;
            });
    }

    restore(queue) {
        const url = appRouter('api.queues.restore', {queue: queue.id});

        return this.http.patch(url);
    }

    moveUp(queue) {
        const url = appRouter('api.queues.sort.update', {
            queue: queue.id,
            to: queue.previous_index,
        });

        return this.http.patch(url);
    }

    moveDown(queue) {
        const url = appRouter('api.queues.sort.update', {
            queue: queue.id,
            to: queue.next_index,
        });

        return this.http.patch(url);
    }

    reorder(queue, order) {
        const url = appRouter('api.queues.publications.reorder', {queue: queue.id});
        return this.http.post(url, {order});
    }

    reorderDocuments(queue, publicationId, editionId, documentOrder) {
        const url = appRouter('api.queues.documents.reorder', {queue: queue.id});
        return this.http.post(url, {
            publication_id: publicationId,
            edition_id: editionId,
            document_order: documentOrder,
        });
    }
}
